export const auto_spin = (t) => ({
	AUTOSPIN_HEADER: {
		value: 'AUTOSPIN SETTINGS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 50,
			letterSpacing: 1,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	AUTOSPIN_ANIM_TEXT: {
		value: t('autoSpin.skip_animation'),
		config: {
			fill: '#EED999',
			fontSize: '26px',
			fontFamily: 'Poppins SemiBold'
		}
	},
	AUTOSPIN_FAST_TEXT: {
		value: t('autoSpin.fast_spin'),
		config: {
			fill: '#EED999',
			fontSize: '26px',
			fontFamily: 'Poppins SemiBold',
			align: 'center'
		}
	},
	AUTOSPIN_NUMBEROFSPIN_TEXT: {
		value: t('autoSpin.number_of_spins'),
		config: {
			fill: '#EED999',
			fontSize: '28px',
			fontFamily: 'Poppins SemiBold',
			align: 'center'
		}
	},
	AUTOSPIN_BTN: {
		value: t('autoSpin.start_autospin'),
		config: {
			fill: '#FFFFFF',
			fontSize: '28px',
			fontFamily: 'Poppins SemiBold',
			align: 'center'
		}
	},
	NUMBER_OF_BETS: {
		value: '',
		config: {
			fontFamily: 'Japanese',
			fontSize: 40,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	NUMBER_OF_BETS_SELECTED: {
		value: '',
		config: {
			fontFamily: 'Japanese',
			fontSize: 40,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BTN_NUMBER_OF_BETS: {
		value: '0',
		config: {
			fontSize: '44px',
			fontFamily: 'Japanese',
			align: 'center',
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	}
});
